/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { CustomerCategory } from "~/models/customerCategory";

export enum Provider {
  AWS = "AWS",
  AZURE = "AZURE",
  GCP = "GCP",
  ALIBABA = "ALIBABA",
  IBM_CLOUD = "IBM_CLOUD",
  ON_PREMISE = "ON_PREMISE",
}

export enum PremiumSupportCSP {
  AWS = "AWS",
  AZURE = "Azure",
  GCP = "GCP",
  NONE = "NONE",
}

export type FiltersProp = {
  provider?: Provider[];
  category?: CustomerCategory[];
  premiumSupportCSP?: PremiumSupportCSP[];
};
